<template>
  <b-card>
    <div v-if="loading">
      <b-skeleton width="100%" height="350px" />
    </div>
    <div v-else>
      <b-row>
        <!-- text and button -->
        <b-col
          sm="5"
          order-sm="1"
          order="2"
          class="d-flex justify-content-between flex-column mt-1 mt-sm-0"
        >
          <div>
            <h3 class="font-weight-bolder mb-3">نمای کلی</h3>

            <h5 class="font-medium-2">
              <div class="d-flex mr-2 mb-1 flex-wrap">
                <b-card-text>
                  <feather-icon size="14" icon="CalendarIcon" /> تاریخ شروع :
                </b-card-text>

                <b-card-text>{{
                  statistics.startSemester
                    ? calcDate(statistics.startSemester)
                    : "نامشخص"
                }}</b-card-text>
              </div>

              <div class="d-flex mr-2 mb-1 flex-wrap">
                <b-card-text
                  ><feather-icon size="14" icon="CalendarIcon" /> تاریخ پایان :
                </b-card-text>

                <b-card-text>{{
                  statistics.endSemester
                    ? calcDate(statistics.endSemester)
                    : "نامشخص"
                }}</b-card-text>
              </div>
              <span
                class="text-danger mr-50"
                v-if="getDiff && getDiff.time && getDiff.time.day < 0"
              >
                <b-card-text>این ترم تمام شده</b-card-text>
              </span>
              <span class="mr-50" v-else-if="getDiff">
                <b-card-text>{{ getDiff.time.day }} روز مانده</b-card-text>
              </span>
            </h5>
            <h5>
              تعداد جلسه ها
              {{ courseStatistics.session_count }}
            </h5>
          </div>
        </b-col>

        <!-- dropdown and chart -->
        <b-col
          sm="7"
          cols="12"
          order-sm="2"
          order="1"
          class="d-flex justify-content-between flex-column text-right"
        >
          <course-progress :progress="courseProgress" />
        </b-col>
      </b-row>
      <hr />

      <!-- progress bar -->
      <b-row class="avg-sessions pt-50">
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            فروش: {{ numberWithCommas(statistics.goal) }} تومان
          </b-card-text>
          <b-progress value="50" max="100" height="6px" />
        </b-col>
        <b-col cols="6" class="mb-2">
          <b-card-text class="mb-50">
            دانشجویان: {{ statistics.users }}
          </b-card-text>
          <b-progress value="60" max="100" height="6px" variant="warning" />
        </b-col>
        <b-col cols="6">
          <b-card-text class="mb-50">
            جریمه پرداخت شده:
            {{ numberWithCommas(statistics.penaltiesPay) }} تومان
          </b-card-text>
          <b-progress
            value="70"
            max="100"
            height="6px"
            variant="success"
            class="mt-25"
          />
        </b-col>
        <b-col cols="6">
          <b-card-text class="mb-50">
            جریمه پرداخت نشده:
            {{ numberWithCommas(statistics.penaltiesNotPay) }} تومان
          </b-card-text>
          <b-progress
            value="90"
            max="100"
            variant="danger"
            height="6px"
            class="mt-25"
          />
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BDropdown,
  BDropdownItem,
  BProgress,
  BCardText,
  BSkeleton,
} from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import Ripple from "vue-ripple-directive";
import { $themeColors } from "@themeConfig";
import courseProgress from "./CourseProgress.vue";
let moment = require("jalali-moment");
export default {
  components: {
    VueApexCharts,
    BCard,
    BRow,
    BCol,
    BButton,
    BCardText,
    BDropdown,
    BDropdownItem,
    BProgress,
    BSkeleton,
    courseProgress,
  },
  directives: {
    Ripple,
  },

  data() {
    return {
      courseStatistics: {},
      loading: false,
      getDiff: {},
    };
  },
  computed: {
    courseProgress() {
      return this.courseStatistics.progress || 0;
    },
    statistics() {
      return {
        penaltiesPay:
          this.courseStatistics.penalties &&
          this.courseStatistics.penalties.payed
            ? this.courseStatistics.penalties.payed
            : 0,
        goal: this.courseStatistics.earning || 0,
        penaltiesNotPay:
          this.courseStatistics.penalties &&
          this.courseStatistics.penalties.not_payed
            ? this.courseStatistics.penalties.not_payed
            : 0,
        endSemester: this.courseStatistics.ended_at || 0,
        startSemester: this.courseStatistics.started_at || 0,
        salesBar: {
          series: [
            {
              colors: ["#000000"],
              data: [],
              name: [],
            },
            {
              colors: ["#ff0000"],

              data: ["10", "20", "30"],
              name: [],
            },
          ],
        },
        users: this.courseStatistics.students || 0,
      };
    },
  },

  created() {
    this.getSemesterStatistics();
  },
  methods: {
    async getSemesterStatistics() {
      this.loading = true;
      try {
        const { data } = await this.$http.get(
          `panel/courses/${this.$route.params.id}/progress`
        );
        this.courseStatistics = data.data;

        this.getDiff = this.getDifference(
          moment.utc(this.courseStatistics.ended_at).local().format("X")
        );

        this.$emit("userCount", [
          this.courseStatistics.students,
          this.courseStatistics.unique_students,
        ]);
      } catch (e) {}
      this.loading = false;
    },
  },
};
</script>
